import { CATEGORIZE_STEP_ERRORS, ErrorTypes, WarningTypes, WRITE_STEP_ERRORS } from '../constants/edit/ArticleValidationConstants';
import { CATEGORIZE_STEP, WRITE_STEP } from '../constants/edit/StepsConstants';
import { DEFAULT_ARTICLE_NAME } from './articleUtils';
import { isBlank } from './stringUtils';
import { isBodyValid } from './tinymceUtils';
const HUBL_REGEX = /{(?:{|#).*(?:}|#)}/;
export function getErrorsByStep(step, errors) {
  switch (step) {
    case CATEGORIZE_STEP:
      return errors.filter(error => CATEGORIZE_STEP_ERRORS.includes(error));
    case WRITE_STEP:
      return errors.filter(error => WRITE_STEP_ERRORS.includes(error));
    default:
      return errors;
  }
}
export function getStepByError(error) {
  if (CATEGORIZE_STEP_ERRORS.includes(error)) {
    return CATEGORIZE_STEP;
  }
  return WRITE_STEP;
}
export function validateArticleState(customSlugEnding, noSelectedListError, noSelectedAccessGroupError, selectedCategoryId, article, isMissingCategoryTranslation, isMissingSubcategoryTranslation, isMissingVariantCategoryTranslation, isMissingVariantSubcategoryTranslation, articleNotInLanguageSupportedByKnowledgeBase, knowledgeBaseIsPrivate) {
  const errors = [];
  const warnings = [];
  if (!article.values.hs_name || article.values.hs_name === DEFAULT_ARTICLE_NAME) {
    errors.push(ErrorTypes.TITLE_ERROR);
  }
  if (!isBodyValid(article.values.hs_body)) {
    errors.push(ErrorTypes.BODY_ERROR);
  } else if (article.values.hs_body.match(HUBL_REGEX)) {
    warnings.push(WarningTypes.ESCAPE_HUBL_WARNING);
  }
  if (articleNotInLanguageSupportedByKnowledgeBase) {
    errors.push(ErrorTypes.ARTICLE_LANGUAGE_NOT_SUPPORTED_BY_KNOWLEDGE_BASE);
  }
  if (isBlank(customSlugEnding)) {
    errors.push(ErrorTypes.SLUG_ERROR);
  }
  if (selectedCategoryId === undefined || selectedCategoryId === null) {
    errors.push(ErrorTypes.CATEGORY_ERROR);
  }
  if (isMissingCategoryTranslation) {
    errors.push(ErrorTypes.CATEGORY_TRANSLATION);
  }
  if (isMissingSubcategoryTranslation) {
    errors.push(ErrorTypes.SUBCATEGORY_TRANSLATION);
  }
  if (isMissingVariantCategoryTranslation) {
    errors.push(ErrorTypes.VARIANT_CATEGORY_TRANSLATION);
  }
  if (isMissingVariantSubcategoryTranslation) {
    errors.push(ErrorTypes.VARIANT_SUBCATEGORY_TRANSLATION);
  }
  if (noSelectedListError) {
    errors.push(ErrorTypes.NO_LIST_SELECTED_ERROR);
  }
  if (noSelectedAccessGroupError) {
    errors.push(ErrorTypes.NO_ACCESS_GROUP_SELECTED_ERROR);
  }
  if (knowledgeBaseIsPrivate && article.values.hs_access_rule_type === 'PUBLIC') {
    errors.push(ErrorTypes.ARTICLE_IS_PUBLIC_IN_PRIVATE_KNOWLEDGE_BASE);
  }
  return {
    errors,
    warnings
  };
}